import { useState, useEffect, Fragment } from 'react';
import { Box } from '@mui/material';
import { Form } from 'react-bootstrap';
import { supabase } from '../supabase';
import confetti from '../assets/confetti.gif';

const steps = ['Welcome', 'Profile'];

export default function Onboarding(props) {
    const {session, setOpenOnboardingModal} = props
    const baseURL = window.location.href.includes("localhost") ? "http://localhost:3000" : "http://eggshelliq.com";
    const [activeStep, setActiveStep] = useState(0);
    const [skipped, setSkipped] = useState(new Set());
    // local vars
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [practiceName, setPracticeName] = useState('');
    
    useEffect(() => {
        const onboardingModalShown = async () => {
            // submit data to supabase
            try {
                const updates = {
                    id: session.user.id,
                    created_at: new Date(),
                    email: session.user.email,
                    onboarded: true
                }
                
                let { error } = await supabase.from('Profile').upsert(updates)
    
                if (error) throw error
            } catch (error) {
                console.log(error.message)
            }
        }

        onboardingModalShown()
        // eslint-disable-next-line
    }, []);

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };

    const handleNext = async () => {
        let tempActiveStep = activeStep;
            
        if (tempActiveStep === (steps.length - 1)) {
            setOpenOnboardingModal(false);
            // redirect user to new window
            let currentURL = window.location.href;
            if (session) {
                if (currentURL === `${baseURL}/login`) {
                window.location.href = `${baseURL}/dashboard`;
                }
            } else {
                if (currentURL.includes("dashboard")) {
                window.location.href = baseURL;
                }
            }
            return 0;
        }
        let newSkipped = skipped;
        if (isStepSkipped(tempActiveStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(tempActiveStep);
        }
        
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const saveData = async () => {
        let newFolderName = practiceName.replace(/ /g,"_");
        try {
            const updates = {
                id: session.user.id,
                first_name: firstName,
                last_name: lastName,
                practice_name: practiceName,
                folder_name: newFolderName
            }
            
            let { error } = await supabase.from('Profile').upsert(updates)

            if (error) throw error
        } catch (error) {
            console.log(error.message)
        }
    }

    const [width, setWidth] = useState(window.innerWidth);
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);
    const isMobile = width <= 768;


    return (
        <Box className={isMobile ? 'mx-0': 'mx-5'}>
            <Fragment>
                <div className='pt-3' style={{height: '475px'}}>
                    <div className={`${activeStep === 0 ? '' : 'hidden'}`}>
                        <div className='flex flex-col justify-center items-center pt-12'>
                            <div
                                className='h-48 rounded-xl flex justify-center items-center'
                                style={{
                                    backgroundImage: `url(${confetti})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: 'cover'
                                }}
                            >
                                <p className='text-4xl text-center font-extrabold tracking-tighter px-4'>Welcome to your new account!</p>
                            </div>
                            <p className='text-xl text-center text-gray font-bold mb-3 mt-16'>Get started by setting your profile.</p>
                            <div className='flex justify-center'>
                                <button
                                    className='h-14 w-64 text-xl bg-eggshell-green hover:bg-eggshell-dark-green text-white mt-8 border-none rounded-xl'
                                    onClick={() => handleNext()}
                                >
                                    Get started
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className={`${activeStep === 1 ? '' : 'hidden'}`}>
                        <div className='flex flex-col items-center'>
                            <p className='text-3xl text-center font-bold mt-4 mb-3'>Set your profile</p>
                            <div className='mt-6' style={{width: isMobile ? '100%' : '70%'}}>
                                <div className="flex justify-center">
                                    <p className='font-semibold text-lg mt-1.5 w-56'>First name:</p>
                                    <Form.Control
                                        type="text"
                                        value={firstName}
                                        onChange={(e) => setFirstName(e.target.value)}
                                        onBlur={() => saveData()}
                                    />
                                </div>
                                <div className="flex justify-center mt-4">
                                    <p className='font-semibold text-lg mt-1 w-56'>Last name:</p>
                                    <Form.Control
                                        type="text"
                                        value={lastName}
                                        onChange={(e) => setLastName(e.target.value)}
                                        onBlur={() => saveData()}
                                    />
                                </div>
                                <div className="flex justify-center mt-4">
                                    <p className='font-semibold text-lg mt-1 w-56'>Practice name:</p>
                                    <Form.Control
                                        type="text"
                                        value={practiceName}
                                        onChange={(e) => setPracticeName(e.target.value)}
                                        onBlur={() => saveData()}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={(activeStep === -1 ? 'hidden' : 'flex justify-between px-3 pt-2 mx-3')}>
                    <button
                        variant='secondary'
                        onClick={handleBack}
                        className={`text-black bg-light-gray-2 border-light-gray-2 px-4 rounded-xl lg:-ml-0 lg:mr-2 -ml-5 mr-2 ${activeStep === 0 || activeStep === 1 ? 'hidden' : 'hover:text-black hover:bg-light-gray-3'}`}
                    >
                        Back
                    </button>
                    <Box sx={{ flex: '1 1 auto' }} />
                    <button
                        className={`${activeStep === 0 || activeStep === -1 ? 'hidden' : `py-2 rounded-xl text-white bg-eggshell-green hover:bg-eggshell-dark-green ${isMobile ? 'px-4 w-100 py-3 text-xl' : 'px-5'} hover:bg-eggshell-dark-green`}`}
                        onClick={handleNext}
                    >
                        Done
                    </button>
                </div>
            </Fragment>
        </Box>
    );
}